import { AppRoute } from '../models';
import { ACLType } from 'modules/authorization';
import { lazyNamed } from 'utils';

const errorRoutes: AppRoute[] = [
  {
    key: 'unauthorized',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/PermissionError'), 'PermissionError'),
    title: 'Unauthorized',
    path: '/not-authorized',
  },
  {
    key: 'general-error',
    access: ACLType.Public,
    Element: lazyNamed(() => import('views/GeneralError'), 'GeneralError'),
    title: '404',
    path: '*',
  },
];

export default errorRoutes;
